import type { Slide } from "@makeit/schema";
import { FreeSlide, FreeElementView } from "./activities/FreeSlide";
import { QuizSlide } from "./activities/QuizSlide";
import { MathSlide, MissingLetterSlide, MissingWordSlide } from "./activities/QuizVariants";
import { TypeAnswerSlide } from "./activities/TypeAnswerSlide";
import { TapItSlide } from "./activities/TapItSlide";
import { MemorySlide } from "./activities/MemorySlide";
import { DragSlide, DragTextSlide, OrderSlide, SequencesImgSlide } from "./activities/DragActivities";
import { ConnectSlide } from "./activities/ConnectSlide";
import { FillWithLettersSlide, PhraseSlide, WordSlide } from "./activities/WordActivities";
import { TraceableSlide } from "./activities/TraceableSlide";
import { PuzzleSlide } from "./activities/PuzzleSlide";
import { PaintSlide, SimbolDrawSlide } from "./activities/DrawActivities";
import { PlaceholderSlide } from "./activities/Placeholder";

/** Slide types without a web implementation (none exist in the Unity player either). */
export const UNIMPLEMENTED: ReadonlySet<Slide["type"]> = new Set(["sort", "imageReveal", "fractions", "scale", "mole", "crossword"]);

export function SlideView({ slide }: { slide: Slide }) {
  return (
    <>
      <Activity slide={slide} />
      <FreeOverlay slide={slide} />
    </>
  );
}

function Activity({ slide }: { slide: Slide }) {
  switch (slide.type) {
    case "free":
      return <FreeSlide slide={slide} />;
    case "quiz":
    case "quizzesQuiz":
    case "trueFalse":
      return <QuizSlide slide={slide} />;
    case "math":
      return <MathSlide slide={slide} />;
    case "missingLetter":
      return <MissingLetterSlide slide={slide} />;
    case "missingWord":
      return <MissingWordSlide slide={slide} />;
    case "typeAnswer":
      return <TypeAnswerSlide slide={slide} />;
    case "tapIt":
      return <TapItSlide slide={slide} />;
    case "memory":
      return <MemorySlide slide={slide} />;
    case "drag":
      return <DragSlide slide={slide} />;
    case "order":
      return <OrderSlide slide={slide} />;
    case "sequencesImg":
      return <SequencesImgSlide slide={slide} />;
    case "dragText":
      return <DragTextSlide slide={slide} />;
    case "connect":
      return <ConnectSlide slide={slide} />;
    case "word":
      return <WordSlide slide={slide} />;
    case "phrase":
      return <PhraseSlide slide={slide} />;
    case "fillWithLetters":
      return <FillWithLettersSlide slide={slide} />;
    case "traceable":
      return <TraceableSlide slide={slide} />;
    case "puzzle":
      return <PuzzleSlide slide={slide} />;
    case "paint":
      return <PaintSlide slide={slide} />;
    case "simbolDraw":
      return <SimbolDrawSlide slide={slide} />;
    default:
      return <PlaceholderSlide slide={slide} />;
  }
}

/** Free elements (decorations, extra text) that any activity slide may carry. */
function FreeOverlay({ slide }: { slide: Slide }) {
  if (slide.type === "free" || slide.freeElements.length === 0) return null;
  return (
    <div className="free-overlay">
      {slide.freeElements.map((el) => (
        <FreeElementView key={el.id} element={el} />
      ))}
    </div>
  );
}
